/* eslint max-classes-per-file: 0 */

import {
  Mark as Data,
  MarkCollection as Collection,
} from '@/typings/api/Marks'
import { SessionsApi as Api } from '@/api/resources'

import { Fabric } from '@/store/createCrudModule'


const { TransformerParams, Adapter } = Fabric<Data, Collection>()

export class SessionsTransformerParams extends TransformerParams {

}

export class SessionsAdapter extends Adapter<Api> {
  public readonly api = new Api();

  public readonly transformerParams = new SessionsTransformerParams();
}
